/* eslint-env browser */
/* globals $ */

// eslint-disable-next-line no-unused-vars
function init(options) {
  let {
    unlimited,
    numberAttempts,
    contentId,
    resourceId,
    total,
    extraDistractorTotal,
    siteUrl,
    canBeGraded,
  } = options;
  let attempts = 0;

  let inCollection = false;
  const has = Object.prototype.hasOwnProperty;

  try {
    inCollection = typeof (window.parent && window.parent.clearAssessment) !== 'undefined';
    window.attempts = attempts;
  } catch (e) {
    // nothing
  }

  // take setTargetHeight out of startMatching so it could be called when window resize
  function setTargetHeight() {
    const dropArray = [];
    $('#matching_sortable1 li').each(function () {
      dropArray.push($(this).outerHeight(true));
    });
    dropArray.sort((a, b) => b - a);

    $('.matching_targetZone').each(function () {
      const pHeight = $(this).find('h2').outerHeight(true); // use text height for each matching_targetZone
      if ($(this).find('.card').length > 0) { // resize after draggables are dropped, set targetzone height based on dropped card
        $(this).find('.matching_sortable2').css('height', `${$(this).find('.card').outerHeight(true)}px`);
        $(this).outerHeight(`${$(this).find('.matching_sortable2').outerHeight(true) + pHeight + 15}px`);
      } else {
        $(this).outerHeight(`${dropArray[0] + pHeight + 15}px`); // each matching_targetZone has different height based on their text
        $(this).find('.matching_sortable2').css('height', `${dropArray[0]+2}px`);
      }
    });

    $('.matching_targetZone').addClass('my-2');
  }
  $(window).load(function(){
    if ($('.non-instructor').hasClass('d-none')) {
      $('.non-instructor').removeClass('d-none');
      setTargetHeight();
      $('.non-instructor').addClass('d-none');
    };
  });
  function resizeWin() {
    // change matching_targetZone height when resize
    setTargetHeight();

    if ($(window).width() < 768) {
      $('.matching_dataB p, .matching_dataA p').css('font-size', '14px');
    } else if (length < 5) {
      $('.matching_dataB p, .matching_dataA p').css('font-size', '18px');
    }
    const zIndex = parseInt($('#matching_q_buttons2').css('z-index'), 10);
    $('#matching_sortable1').css({ 'z-index': zIndex });
  }

  function mark(resultObject) {
    const result = { ...resultObject };
    attempts += 1;
    if (inCollection) { window.attempts = attempts; }

    let attemptTxt = `<h3 class="h5">You have ${Math.max(0, numberAttempts - attempts)} attempts remaining`;
    if (Math.max(0, numberAttempts - attempts) > 0) attemptTxt += ', please remain in the current browser session to utilise these.</h3>';
    else attemptTxt += '.</h3>';
    if (unlimited) attemptTxt = '';

    $('#matching_instructions').html(`${attemptTxt}`);

    if (result.feedback.incorrectIds) {
      result.feedback.incorrectIds.forEach((item) => {
        const div = $(`#B${item}.matching_dataB`);
        div.closest('.matching_targetZone').children(':first-child div .matching_fb_icon').html('<i class="fa fa-times-circle g-color-secondary"></i>');
        div.siblings('.markResult').html('incorrect');
        $(div).addClass('g-color-secondary');
        $(div).find('p').addClass('g-color-secondary');
        div.closest('.matching_targetZone').removeClass('bg-success');
        div.closest('.matching_targetZone').addClass('bg-danger');
        div.closest('.matching_targetZone').removeClass('g-bg-lightblue');
      });
    } else result.feedback.incorrectIds = [];

    if (result.feedback.correctIds) {
      result.feedback.correctIds.forEach((item) => {
        const div = $(`#B${item}.matching_dataB`);
        div.closest('.matching_targetZone').children(':first-child').html('<i class="fa fa-check-circle g-color-secondary"></i>');
        div.siblings('.markResult').html('correct');
        $(div).addClass('g-color-secondary');
        $(div).find('p').addClass('g-color-secondary');
        div.closest('.matching_targetZone').removeClass('bg-danger');
        div.closest('.matching_targetZone').addClass('bg-success');
        div.closest('.matching_targetZone').removeClass('g-bg-lightblue');
        div.addClass('ui-state-disabled');
      });
    } else result.feedback.correctIds = [];

    if (!unlimited && attempts >= numberAttempts) {
      $('#matching_sortable1 li, .matching_sortable2 > li').addClass('ui-state-disabled');
      $('#matching_q_check2').css('display', 'none');
    }

    $('#matching_q_fb2').removeClass('d-none');
    $('#matching_correctAnswer').css('display', 'block');

    if (result.correct.toString() === 'true') {
      // perfect score
      $('#matching_q_fb2 .h4')
        .html(`<h2 class="h4">You matched ${result.feedback.correctIds.length} correctly and ${result.feedback.incorrectIds.length} incorrectly.</h2>`)
        .append(`<p class="text-white"><strong>General Feedback:</strong> ${result.feedback.overall.replace(/(<p[^>]+?>|<p>)/img, '<p class="text-white">')}</p>`);
      if (unlimited) {
        $('#matching_q_new2').css('display', 'block');
      } else {
        $('#matching_q_new2').css('display', 'none');
      }
      $('#matching_q_check2').css('display', 'none');
      $('#q_skip2').css('display', 'none');
    } else {
      $('#matching_q_fb2 .h4')
        .html(`<h2 class="h4">You matched ${result.feedback.correctIds.length} correctly and ${result.feedback.incorrectIds.length} incorrectly.</h2>`)
        .append(`<p class="text-white"><strong>General Feedback:</strong> ${result.feedback.overall.replace(/(<p[^>]+?>|<p>)/img, '<p class="text-white">')}</p>`);

      if (unlimited) {
        $('#matching_q_new2').css('display', 'block');
      } else {
        $('#matching_q_new2').css('display', 'none');
        $('#matching_show_answers').css('display', 'block');
      }
      $('#q_skip2').css('display', 'none');
    }
    resizeWin();
  }

  window.matching_mark = mark;

  $(document).ready(() => {
    $('p img').each(function () {
      if ($(this).attr('src').startsWith('../..')) {
        const src = $(this).attr('src').replace(/\..\/\../g, `${siteUrl}`);
        $(this).attr('src', src);
      }
    });

    // make sure texts are wrapped in p tags
    $('#matching_targets .matching_targetZone').each(function () {
      if ($(this).find('h2').find('p').length === 0) {
        const txt = $(this).find('h2').html();
        $(this).find('h2').html(`<p>${txt}</p>`);
      }
    });

    $('#matching_sortable1 li').each(function () {
      if ($(this).find('.card-body').find('p').length === 0) {
        const cardTxt = $(this).find('.card-body').html();
        $(this).find('.card-body').html(`<p>${cardTxt}</p>`);
      }
    });

    // draggables have equal top&bottom margins
    $('.matching_dataA p').addClass('my-1');

    // if more than 5 draggables, set padding & font size based on number of draggables
    const length = extraDistractorTotal && extraDistractorTotal > 0? total + extraDistractorTotal : total; // Why not just use total?
    if (length > 5 || $(window).width() < 768) {
      const maxLength = 12;
      const cardPadding = $('#matching_sortable1').find('.card-body').css('padding');
      const reducedPadding = Number(cardPadding.substring(0, cardPadding.length - 2))
        * ((maxLength - length) / maxLength);
      $('#matching_sortable1').find('.card-body').css('padding', `${reducedPadding}px`);
      $('.matching_dataB p, .matching_dataA p').css('font-size', '14px');
    } else {
      $('.matching_dataB p, .matching_dataA p').css('font-size', '18px');
    }


    // draggable behind modals
    const btnZindex = parseInt($('#matching_q_buttons2').css('z-index'), 10);
    $('#matching_sortable1').css({ 'z-index': btnZindex });

    $('#q_block_matching').css('display', 'none').removeClass('hidden');

    function startMatching() {
      $('#q_block_matching').css('display', 'block');
      $('#matching_q_fb2').addClass('d-none');
      $('#matching_correctAnswer').css('display', 'none');
      $('#matching_q_new2').css('display', 'none');
      $('#q_block_matching').css('display', 'none');

      function newQuestion2(command) {
          $('#matching_q_fb2').addClass('d-none');
          $('#matching_correctAnswer').css('display', 'none');
          $('#matching_q_new2').css('display', 'none');
          $('#matching_show_answers').css('display', 'none');
          $('#matching_sortable1').randomize('li');
          $('#matching_targets').randomize('div.matching_targetZone');
          $('#q_block_matching').css('display', 'block');
          $('#matching_q_check2').css('display', 'block');
          $('#q_skip2').css('display', 'block');
          setTargetHeight();
        if (command === 'reset') {
          $('.matching_targetZone').removeClass('bg-success').removeClass('bg-danger').addClass('g-bg-lightblue');
          $('.matching_targetZone').children(':first-child div .matching_fb_icon').html('');
          $('.matching_dataB').removeClass('g-color-secondary').removeClass('ui-state-disabled');
          $('.matching_dataB').find('p').removeClass('g-color-secondary');
          $('#matching_sortable1').html(cache).sortable("refresh");
          $('.matching_sortable2').empty();
          $('.matching_dataA').parent().removeAttr("style");
          $('.markResult').html('');
        }

        let attemptTxt = `<h3 class="h5">You have ${numberAttempts} attempts remaining.</h3>`;
        if (unlimited) attemptTxt = '';

        $('#matching_instructions').html(`${attemptTxt}`);
      }

      $('#matching_q_check2').click(() => {
        matching_submitQuiz();
      });


      function matching_submitQuiz() {
        // get number of matching pairs
        let att = 0;
        let score;
        const formData = {
          response: {
            matchingResponse: [],
            total,
          },
          resourceId,
          contentId,
          contentType: 'matching',
          inCollection,
          total,
        };

        $('.matching_sortable2').each(function () {
          // TODO - change to id check so wysiwyg junk not an issue
          formData.response.matchingResponse.push({
            a: $(this).parent()
              .find('.matching_dataA')
              .attr('id')
              ? $(this).parent()
                .find('.matching_dataA')
                .attr('id')
                .slice(1)
              : undefined,
            b: $(this).parent()
              .find('.matching_dataB')
              .attr('id')
              .slice(1)
          });

          if ($(this).parent().find('.matching_dataA').html()) { // attempted a reseponse
            att += 1;
          }
        });

        $.ajax({
          type: 'POST',
          url: '/access/content/evaluate',
          data: formData,
          dataType: 'json',
          encode: true,
        }).done((data) => {
          const result = (data && data.result && data.result.result)
            ? data.result.result
            : data.result;
          mark(result);

          if (att === 0) {
            // didn't attempt
            $('#matching_q_fb2 .h4').html('<p class="text-white"><strong>General Feedback:</strong> You should try at least one match.</p>');
            // enable draggables so an attempt can be made
            if (unlimited || attempts < numberAttempts) {
              $('#matching_sortable1 li').removeClass('ui-state-disabled');
            }
          }
          if ($('#footer').length > 0) {
            const footerHeight = Number($('#footer').outerHeight(true));
            if ($('body').height() + footerHeight > $(window).height()) {
              $('#footer').css('position', 'inherit');
            }
          }

          $('html, body').animate({
            scrollTop: $('#matching_fb_div').offset().top,
          }, 1000);


          // for resource collection assessment
          if (inCollection) {
            if (result && result.feedback && result.feedback.correctIds) {
              score = parseFloat((result.feedback.correctIds.length / total).toFixed(2));
            } else {
              score = 0;
            }
            window.parent.clearAssessment(score, formData, result);
          }
        })
        .fail(function(err) {
          if (err && err.responseJSON && err.responseJSON.message) {
            var errMsg = err.responseJSON.message;

            if (errMsg === 'content has expired') {
              $("#matching_q_fb2")
                .removeClass("d-none");

              $("#matching_q_fb2 .h4")
                .html("Your Session has timed out")
                .append(
                `<p class="text-white">
                  Your activity could not be evaluated because your session has timed out. This is likely because you are viewing multiple pieces of content at the same time. Please reload this activity and try again.
                </p>`
              );

              $("#matching_q_new2")
                .css("display", "none");

              $("#matching_q_check2")
                .css("display", "none");

              $("#q_skip2")
                .css("display", "none");

              $("html, body").animate({
                scrollTop: $("#matching_fb_div").offset().top
              }, 1000);
            }
          }
        });
      }

      $('#matching_q_new2').click(() => {
        // reset interface for another attempt
        $('body').scrollTop(0);
        $('.fixedElement').css({ position: 'relative', top: '0px' });
        newQuestion2('reset');
      });

      $('#matching_show_answers').click(function () {
        const self = $(this);
        const formData = {
          resourceId,
          contentId,
          contentType: 'matching',
          response: {
            getCorrect: true,
          },
          inCollection,
        };

        $.ajax({
          type: 'POST',
          url: '/access/content/evaluate',
          data: formData,
          dataType: 'json',
          encode: true,
        }).done((data) => {
          const result = (data && data.result && data.result.result)
            ? data.result.result
            : data.result;
          const correctDiv = $('#matching_correctAnswer');
          Object.keys(result.feedback.correctResponse).forEach((key) => {
            if (has.call(result.feedback.correctResponse, key)) {
              let { a, b } = result.feedback.correctResponse[key];
              if (a.tagname !== 'img') {
                a = a.replace(/(<p[^>]+?>|<p>|<\/p>)/img, '');
                a = a.replace(/\..\/\../g, `${siteUrl}`);
              }
              if (b.tagname !== 'img') {
                b = b.replace(/(<p[^>]+?>|<p>|<\/p>)/img, '');
                b = b.replace(/\..\/\../g, `${siteUrl}`);
              }
              correctDiv.append(`<div style="display:block; clear:both">${a} : ${b}</div>`);
            }
          });

          self.css('display', 'none');
          $('#matching_answerModal').modal('show');
        });
      });

      $('#q_exit2').click(() => {
        setTimeout(() => {
          window.history.back();
        }, 500);
      });
      newQuestion2('new');
    } // end startMatching

    // randomize the order of elements from the passed selector
    // (draggables and droppable descriptions)
    $.fn.randomize = function (selector) {
      const $elems = selector ? $(this).find(selector) : $(this).children();
      const $parents = $elems.parent();
      $parents.each(function () {
        $(this)
          .children(selector)
          .sort(() => Math.round(Math.random()) - 0.5)
          .detach()
          .appendTo(this);
      });
      return this;
    };

    // init JQuery UI Sortable
    $(() => { // TOOD - we're already in a ready block, isn't this redundant?
      $('ul.droptrue').sortable({
        helper: 'clone',
        connectWith: 'ul',
        cancel: '.ui-state-disabled',
        placeholder: 'dropPlaceHolder',
        receive: () => {},
      });
      $('#matching_sortable1, #sortable2').disableSelection();
    });

    // event to handle when a list receives a new draggable
    $('#matching_sortable1, .matching_sortable2').on('sortreceive', function (event, ui) {
      resetHeight($(this), ui.item);
      srUpdate($(this), ui.item);
      $(this).append(ui.item); // force the new draggable to bottom of list
      $(this).trigger('sortupdate'); // manually fire the UI event
      ui.item.addClass('isGrabbed');
      if ($(this).children().length > 1) {
        $(this).children(':first').removeClass('isGrabbed');
        $('#matching_sortable1').append($(this).children(':first')); // force the first child back to the list on the left, limits 1 draggable to a droppable.
        $('#matching_sortable1').find('.card').css('border-color', '');
      }


    });

    function resetHeight(box, draggable) {
      const boxHeightPrev = parseFloat(box.css('height'));
      const draggableHeight = parseFloat(draggable.outerHeight(true)); // get draggable height
      box.css('height', draggableHeight+2); // set box height to draggable height
      const zoneHeightPrev = parseFloat(box.closest('.matching_targetZone').css('height'));
      const zoneHeight = zoneHeightPrev + (draggableHeight - boxHeightPrev);
      box.closest('.matching_targetZone').css('height', zoneHeight); // set matching_targetZone height according to draggableheight, especially necessary when using img-fluid
      box.find('.card').css('border-color', 'transparent'); // remove border of draggers in targetzone
    }

    function srUpdate(box, draggable) {
      const draggableTxt = draggable.find('.card-body').html();
      const targetTxt = box.siblings('h2').html();
      $('#dropUpdate').html(draggableTxt + ' moved to ' + targetTxt);
      setTimeout(function(){ $('#dropUpdate').html('') }, 1000);
    }

    startMatching();

    $(window).resize(() => {
      resizeWin();
    });

    $('#matching_access').click(() => {
      $('#matching_accessibleModal').modal('show');
    });

    // give the list items a tab index
    $('#matching_sortable1 li').attr('dataindex', (i) => (i + 1));

    $('#matching_sortable1 li').attr('aria-haspopup', 'true');

    // add listener for dataindex on drag and drop
    $('#matching_sortable1').sortable({
      update: () => {
        $('#matching_sortable1 li').attr('dataindex', (i) => (i + 1));
        $('.matching_sortable2').children('li').attr('dataindex', function () {
          return Number($('#matching_sortable1 li').length) + Number($(this).closest('.matching_targetZone').attr('id').replace(/[^0-9.]/g, ''));
        });
      },
    });
    var cache = $("#matching_sortable1").html();

    function handleEnter(event) {
      if (event.key === 'Enter') {
        this.click();
      }
    }

    $('#matching_q_check2').keydown(handleEnter);
    $('#matching_q_new2').keydown(handleEnter);
    $('#matching_show_answers').keydown(handleEnter);
    $('#q_exit2').keydown(handleEnter);
    $('#matching_access').keydown(handleEnter);
    $('.ui-sortable-handle').keydown(handleEnter);

    $('#matching_accessibleModal').on('shown.bs.modal', () => {
      $('#accessibilityModalCloseBtn').focus();
    });

    $('#matching_accessibleModal').on('hidden.bs.modal', () => {
      $('#matching_access').focus();
    });

    let matching_popoverdataindex = 0;
    let matching_popoverTemplate = '<ul class="list-group">';

    $('.matching_dataB').each(function () {
      matching_popoverTemplate += `<li class="list-group-item popover-list-item" data-id="${
        $(this).attr('id')}" dataindex="${matching_popoverdataindex}"><a href='#'>${
        $(this).text()}</a></li>`;
      matching_popoverdataindex += 1;
    });

    matching_popoverTemplate += '</ul><div class="modal-footer"><a href="#" class="closePopover btn-sm u-btn-primary">Close</a></div>';
    $('.matchingCT[data-bs-toggle="popover"]').attr('data-bs-content', matching_popoverTemplate);

    $('.matchingCT[data-bs-toggle="popover"]').popover({
      html: true,
      trigger: 'manual',
      sanitize: false,
      container: 'body',
      template: '<div class="popover" role="popover" aria-label="Target Drop Zones (press Enter to drop)"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div id="matching_popover_body" class="popover-body"></div></div>'
    });

    $('#matching_sortable1 li').on('click', function(e) {
      e.preventDefault();
        if ($(this).hasClass('ui-state-disabled')) {
          $(this).popover('disable');
        } else {
          $(this).popover('show');
        }
    });

    $('#matching_sortable1 li').on('shown.bs.popover', function() {
      const popupID = $(this).attr('aria-describedby');
      $(`#${popupID}`).find('li.list-group-item').first().find('a').focus();
      //trap keyboard focus in popover when open
      trapFocus($("#"+popupID));
      //currently selected matching item
      let matchingItem = $(this);
        $('#matching_popover_body ul a').on('click', function(e) {
            e.preventDefault();
            if ($(this).parent().hasClass('popover-list-item')) {
              const popupID = $(this).parent().closest('.popover').attr('id');
              e.preventDefault();
              if ($(`#${$(this).parent().attr('data-id')}`).next('ul').length !== 0) {
                $(`#${$(this).parent().attr('data-id')}`).next('ul').find('li').removeClass('isGrabbed');
                  $('#matching_sortable1').append($(`#${$(this).parent().attr('data-id')}`).next('ul').find('li'));
                  $('#matching_sortable1').find('.card').css('border-color', '');
              }
              $(`#${$(this).parent().attr('data-id')}`).next('ul').append($(`[aria-describedby="${popupID}"]`));
              resetHeight($(`#${$(this).parent().attr('data-id')}`).next('ul'), $(`[aria-describedby="${popupID}"]`));
              $(`[aria-describedby="${popupID}"]`).addClass('isGrabbed');
              $(this).parent().closest('.popover').popover('hide');
              $('#matching_sortable1 li').attr('dataindex', (i) => (i + 1));
              $('.matching_sortable2').children('li').attr('dataindex', function () {
                  return (Number($('#matching_sortable1 li').length) + Number($(this).closest('.matching_targetZone').attr('id').replace(/[^0-9.]/g, '')));
              });
              srUpdate($(`#${$(this).parent().attr('data-id')}`).next('ul'), $(`[aria-describedby="${popupID}"]`));
            }
        });

         $('#matching_sortable1 li').on('hidden.bs.popover', function() {
           if ($('#matching_sortable1 li').length !== 0) {
              //return focus to the selected matching item
              $(matchingItem).focus();
          } else {
              $('#dropUpdate').append('<p>Activity completed</p>')
              $('#matching_q_check2').find('a').focus();
          }
         });

        $('.closePopover').on('click', function(e) {
          e.preventDefault();
          $(this).closest('.popover').popover('hide');
          if ($('#matching_sortable1 li').length !== 0) {
              //return focus to the selected matching item
              $(matchingItem).focus();
          } else {
              $('.matching_sortable2').find('li').first().focus();
          }
        });
    });
  });
}
